import { useTranslation } from 'react-i18next';

const SafetyPage = () => {
  const { t, i18n } = useTranslation();

  return (
    <div className="min-h-screen bg-gray-50 pt-16" dir={i18n.language === 'he' ? 'rtl' : 'ltr'}>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-8">{t('nav.safety')}</h1>
          
          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold mb-4">{t('nav.safety')} Equipment</h2>
              <p className="text-gray-600 text-lg">
                {i18n.language === 'he' 
                  ? 'ציוד בטיחות מתקדם להגנה מקסימלית'
                  : 'Advanced safety equipment for maximum protection'
                }
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-semibold mb-4">
                  {i18n.language === 'he' ? 'מוצרי בטיחות' : 'Safety Products'}
                </h3>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'מגני ברכיים' : 'Knee Pads'}
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'מגני מרפקים' : 'Elbow Pads'}
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'מגני כפות ידיים' : 'Wrist Guards'}
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'מגני גב' : 'Back Protectors'}
                  </li>
                </ul>
              </div>
              
              <div>
                <h3 className="text-xl font-semibold mb-4">
                  {i18n.language === 'he' ? 'תכונות הגנה' : 'Protection Features'}
                </h3>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'חומרים קלים וחזקים' : 'Lightweight & strong materials'}
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'כוונון מדויק' : 'Precise adjustment'}
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'אוורור מעולה' : 'Excellent ventilation'}
                  </li>
                  <li className="flex items-center">
                    <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                    {i18n.language === 'he' ? 'עמידות בפני שחיקה' : 'Abrasion resistance'}
                  </li>
                </ul>
              </div>
            </div>

            <div className="text-center mt-8">
              <p className="text-gray-600 mb-4">
                {i18n.language === 'he' 
                  ? 'צרו קשר למידע על זמינות ומחירים'
                  : 'Contact us for availability and pricing information'
                }
              </p>
              <button 
                onClick={() => window.location.href = '/service'}
                className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
              >
                {i18n.language === 'he' ? 'צור קשר' : 'Contact Us'}
              </button>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default SafetyPage; 